// extracted by mini-css-extract-plugin
export var container = "pricedelivery-module--container--P1EYX";
export var left = "pricedelivery-module--left--YNhtr";
export var right = "pricedelivery-module--right--+Crub";